unable to read source [project]/packages/src/components/compound/switchRow/SwitchRow.tsx